<!-- <mat-toolbar color="primary">
  <mat-toolbar-row>
    <button mat-icon-button fxFlex fxLayout="row" (click)="changeLanguage()" fxLayoutAlign="flex-end">
      {{languague}}
    </button>
  </mat-toolbar-row>
</mat-toolbar> -->
<div class="loginWrapper gradient-custom">
  <div>
    <section>
      <p class="welcomeText" i18n>Welcome to</p>
      <p class="adminText">cS<a class="registeredSymbol">®</a> ADMIN PORTAL</p>
    </section>

    <mat-card panel class="loginCard" *ngIf="hasLoginCred">
      <mat-card-header class="loginHeader">
        <mat-card-title class="loginTitle" i18n>LOGIN</mat-card-title>
      </mat-card-header>
      
      <mat-card-content class="loginContent">
        <form>
          <mat-form-field class="my-form-field">
            <mat-label>Schema</mat-label>
            <mat-select [(value)]="selectedDbCredential">
              <mat-option *ngFor="let s of schemaList" [value]="s">{{s}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="my-form-field">
            <mat-label i18n>User Name</mat-label>
            <input matInput type="text" [formControl]="userName" required>
            <mat-error *ngIf="userName.invalid">{{getErrorMessage()}}</mat-error>
          </mat-form-field>
          
          <mat-form-field class="my-form-field">
            <mat-label i18n>Password</mat-label>
            <input matInput type="password" [formControl]="password" required>
            <mat-error *ngIf="password.invalid">{{getErrorMessage()}}</mat-error>
          </mat-form-field>
        </form>
      </mat-card-content>

      <mat-card-actions class="actionBox">  
        <div class="buttonDiv">   
        <button mat-raised-button type="submit" color="primary" class="loginButton" (click)="authentificate()">LOGIN</button>     
        <button mat-raised-button (click)="forgotPasswordSwitch()" color="primary" class="resetButton" type="button" i18n>FORGOT PASSWORD</button>
        </div>
      </mat-card-actions>     
      <mat-error style="margin-top: 8x;">{{authentificationMessage}}</mat-error>      
    </mat-card>

    <mat-card panel class="loginCard" *ngIf="hasPasswordChange">
      <mat-card-header class="loginHeader">
        <mat-card-title class="loginTitle" i18n>
          CHANGE PASSWORD
        </mat-card-title>
      </mat-card-header>
  
      <mat-card-content class="loginContent">
        <form>
          <mat-form-field class="my-form-field">
            <mat-label i18n>Old Password</mat-label>
            <input matInput type="password" [formControl]="oldpassword" required>
            <mat-error *ngIf="password.invalid">{{getErrorMessage()}}</mat-error>
          </mat-form-field>
  
          <mat-form-field class="my-form-field">
            <mat-label i18n>New Password</mat-label>
            <input matInput type="password" [formControl]="newpassword" required>
            <mat-error *ngIf="password.invalid">{{getErrorMessage()}}</mat-error>
          </mat-form-field>
  
          <mat-form-field class="my-form-field">
            <mat-label i18n>Confirm Password</mat-label>
            <input matInput type="password" [formControl]="repassword" required>
            <mat-error *ngIf="password.invalid">{{getErrorMessage()}}</mat-error>
          </mat-form-field>
        </form>
      </mat-card-content>
  
      <mat-card-actions class="actionBox">     
        <button mat-raised-button type="submit" color="primary" class="loginButton"
          (click)="updatePassword()" i18n>UPDATE PASSWORD
        </button>     
      </mat-card-actions>
      <mat-error style="margin-top: 8x;">{{authentificationMessage}}</mat-error>
    </mat-card>

    <mat-card panel class="loginCard" *ngIf="IsPasswordForgot">
      <mat-card-header class="loginHeader">
        <mat-card-title class="loginTitle" i18n>
          RESET PASSWORD
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field class="my-form-field">
          <mat-label i18n>Username</mat-label>
          <input matInput type="text" i18n [formControl]="userName" required>
          <mat-error *ngIf="userName.invalid">{{getErrorMessage()}}</mat-error>
        </mat-form-field>
  
        <mat-form-field class="my-form-field">
          <mat-label i18n>First Name</mat-label>
          <input matInput type="text" i18n [formControl]="firstName" required>
          <mat-error *ngIf="firstName.invalid">{{getErrorMessage()}}</mat-error>
        </mat-form-field>
  
        <mat-form-field class="my-form-field">
          <mat-label i18n>Last Name</mat-label>
          <input matInput type="text" i18n [formControl]="lastName" required>
          <mat-error *ngIf="lastName.invalid">{{getErrorMessage()}}</mat-error>
        </mat-form-field>
  
        <mat-form-field class="my-form-field">
          <mat-label i18n>Email</mat-label>
          <input matInput type="text" i18n [formControl]="email" required>
          <mat-error *ngIf="email.invalid">{{getErrorMessage()}}</mat-error>
        </mat-form-field>
      </mat-card-content>
  
      <mat-card-actions class="actionBox">  
        <div class="buttonDiv">   
          <button mat-raised-button type="submit" color="primary" (click)="forgotPassword()" class="loginButton" i18n>UPDATE</button>           
          <button mat-raised-button (click)="forgotPasswordSwitch()" type="button" color="primary" class="resetButton">BACK TO LOGIN</button>        
      </div>
    </mat-card-actions> 
    <mat-error style="margin-top: 8x;">{{authentificationMessage}}</mat-error>
    </mat-card>
  </div>

  <!-- <mat-card panel class="schemaCard" *ngIf="hasDbCred">
    <mat-card-header>
      <mat-card-title i18n>
        Database
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-form-field appearance="fill">
        <mat-label i18n>User Name</mat-label>
        <input matInput type="text" i18n [formControl]="dbName" required>
        <mat-error *ngIf="dbName.invalid">{{getErrorMessage()}}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" fxLayoutAlign="row">
        <mat-label i18n>Password</mat-label>
        <input matInput type="password" i18n [formControl]="dbpassword" required>
        <mat-error *ngIf="dbpassword.invalid">{{getErrorMessage()}}</mat-error>
      </mat-form-field>
      <mat-form-field matInput type="text" appearance="fill" fxLayoutAlign="row">
        <mat-label i18n>Host</mat-label>
        <input matInput [formControl]="host" required>
        <mat-error *ngIf="host.invalid">{{getErrorMessage()}}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" fxLayoutAlign="row">
        <mat-label i18n>ServiceName</mat-label>
        <input matInput type="text" i18n [formControl]="serviceName" required>
        <mat-error *ngIf="serviceName.invalid">{{getErrorMessage()}}</mat-error>
      </mat-form-field>
    </mat-card-content>
    <button mat-raised-button type="submit" *ngIf="dbName.valid&&dbpassword.valid&&host.valid&&serviceName.valid"
      color="primary" (click)="addDbCred()" i18n>Speichern
    </button>
    <mat-error style="margin-top: 8x;">{{authentificationMessage}}</mat-error>
  </mat-card> -->
</div>